angular.module('bmsApp.settings')
	.factory('AuthEmployeeSvc', function ($http, $log, $window, $q, CRUDSvc, AUTH_EMPLOYEE_API) {

		return {
			index: function (params) {
				return CRUDSvc.get(AUTH_EMPLOYEE_API.INDEX, params);
			},
			convertToUser: function(params) {
				return CRUDSvc.post(AUTH_EMPLOYEE_API.CONVERT, params);
			}
		}

	})
	.constant('AUTH_EMPLOYEE_API', {
		INDEX: 'api/auth-employee/index',
		CONVERT: 'api/auth-employee/convert',
	});



